import { connect } from 'react-redux';

import { SearchResults } from 'ha/pages/Search/components/SearchResults';
import {
  getListings,
  hasCitiesNearby,
  getCityCanonical,
  getCityName,
  getCountryCode,
  getIsImperialSystem,
} from 'ha/pages/Search/selectors';
import { GlobalState } from 'ha/types/store';

const SearchResultsContainer = connect((state: GlobalState) => ({
  items: getListings(state),
  cityCanonical: getCityCanonical(state),
  countryCode: getCountryCode(state),
  shouldShowCitiesNearby: hasCitiesNearby(state),
  cityLocalizedName: getCityName(state),
  isImperialSystem: getIsImperialSystem(state),
}))(SearchResults);
export { SearchResultsContainer };
